module.exports = __webpack_public_path__ + "img/foot_scanner_icon.5f4aa152.svg";